export default __webpack_public_path__ + "static/media/office.e97dd6f0.jpg";